/**
 * Resolve a tool's agent parameter schema from the node editor's
 * `_agentParameterSchema` draft and the persisted schema. A `null` draft means
 * every parameter was deleted, so only an absent (`undefined`) draft falls back
 * to the persisted schema.
 */
export function resolveAgentParameterSchema<T extends object>(
  draft: T | null | undefined,
  persisted: T | null | undefined,
): T | undefined {
  if (draft !== undefined) return draft ?? undefined;
  return persisted ?? undefined;
}
